<template>
  <div>
    <show :dialog="showDialog" :item="editedItem"></show>
    <v-card>
      <v-toolbar card>
        <v-text-field clearable
          append-icon="search"
          label="ค้นหา"
          single-line
          hide-details
          v-model="pagination.q"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn fab dark small color="primary" @click.native.stop="dialog = true" class="text-xs-center" slot="activator">
            <v-icon dark>playlist_add</v-icon>
          </v-btn>
          <span>Add Company</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :loading="loading"
          :headers="headers"
          :items="loadedItems"
          :total-items="totalItems"
          :pagination.sync="pagination"
          class="elevation-0"
        >
        <v-progress-linear slot="progress" color="teal" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <tr @click="editItem(props.item)">
            <td class="text-xs-left">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
            <td class="text-xs-left" nowrap>{{ props.item.authority }}</td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.officers ? props.item.officers.length : 0 }}</td>
          </tr>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop, itemsLength }">
          From {{ pageStart }} to {{ pageStop }} of {{ itemsLength }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import swal from 'sweetalert2'
import Show from './show'

export default {
  name: 'Gang',
  components: { Show },
  data () {
    return {
      addDialog: false,
      showDialog: false,
      loading: false,
      valid: false,
      headers: [
        { text: '#', value: 'idx', sortable: false, align: 'left' },
        { text: 'บทบาท', value: 'authority', sortable: true, align: 'left' },
        { text: 'คำอธิบาย', value: 'description', sortable: true, align: 'center' },
        { text: 'สมาชิก', value: 'numberOfMembers', sortable: false, align: 'center' }
      ],
      search: '',
      defaultItem: {
        authority: null,
        description: null,
        officers: []
      },
      editedItem: {
        authority: null,
        description: null,
        officers: []
      },
      editedIndex: -1,
      pagination: {
        q: '',
        sortBy: 'authority',
        page: 1,
        rowsPerPage: 10,
        descending: false
      },
      totalItems: 0,
      loadedItems: []
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? `New ${this.$options.name}` : `Edit ${this.$options.name}`
    }
  },
  methods: {
    reset () {
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    addItem () {
      this.reset()
      this.dialog = true
    },
    closeShowDialog () {
      this.showDialog = false
      setTimeout(() => this.reload(), 300)
    },
    editItem (item) {
      this.$store.dispatch('gang/fetchItem', item.id)
        .then((response) => {
          this.editedItem = response.data
          this.loading = false
          this.showDialog = true
        }).catch((error) => {
          this.loading = false
          swal('เกิดข้อผิดพลาด!', (error.response.data) ? error.response.data.message : error.message, 'error')
        })
    },
    save (item) {
      let dispatchName =
        item.id && item.id > 0 ? 'gang/update' : 'gang/create'
      this.loading = true
      this.$store.dispatch(dispatchName, item)
        .then(response => {
          this.loading = false
          swal({
            title: 'บันทึกเรียบร้อย!',
            type: 'success'
          }).then(response => {
            this.close()
          })
        }).catch(error => {
          this.loading = false
          swal('เกิดข้อผิดพลาด!', (error.response.data) ? error.response.data.message : error.message, 'error')
        })
    },
    reload: _.debounce((self) => {
      self.loading = true
      self.reset()
      self.$store.dispatch('gang/loadItems', self.pagination)
        .then((response) => {
          self.totalItems = response.data.totalItems
          self.loadedItems = response.data.items
          self.loading = false
        }).catch((error) => {
          self.loading = false
          swal('เกิดข้อผิดพลาด!', (error.response.data) ? error.response.data.message : error.message, 'error')
        })
    }, 1000)
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload(this)
    },
    'pagination.q' () {
      this.reload(this)
    },
    'pagination.page' () {
      this.reload(this)
    },
    'pagination.descending' () {
      this.reload(this)
    }
  },
  mounted () {
    this.reload(this)
    this.$events.on('closeDialog', (eventData) => {
      if (eventData === 'addDialog') {
        this.closeAddDialog()
        this.createRowLiningRequest = null
      } else if (eventData === 'showDialog') {
        this.closeShowDialog()
      }
    })
  },
  beforeDestroy () {
    this.$events.remove('closeDialog')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/gang/index.vue